<template>
  <div class="wg-row" style="justify-content:center;">
    <template v-if="myLicenses.length > 0">
      <!-- LISTA LICENZE -->
      <div class="vertical-height-div" style="height:20px;"></div>
      <div style="font-size:22px;">{{ $anm22.strLang(lang, 'My restaurants', 'I miei ristoranti') }}</div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row" style="justify-content:center;">
        <license-card 
            v-for="(license,index) in myLicenses"
            :key="'ml-'+index"
            :cover="license.coverImg"
            :name="license.name || ($store.getters['works/get'](license.work) ? $store.getters['works/get'](license.work).name : '')"
            :isFoodLicense="true"
            :click="() => goToHomepage(license.licenseHash)"
            :showStatus="true"
            :open="!license.interrupted"
            :masterLastPing="license.lastPing"
        ></license-card>
      </div>
    </template>
    <template v-else>
      <img :src="$anm22.icons.getWorldIcon('scanBlack')" style="height:150px;">
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="com-anm22-app-text-xxl">
        {{ $anm22.strLang(
          lang, 
          'Scan the restaurant QRCode with the camera app of your device.', 
          'Scansiona il QRCode del ristorante con l\'applicazione fotocamera del tuo dispositivo.'
        ) }}
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import LicenseCard from '../components/LicenseCard.vue';
// Per ottenere l'istanza google
// import {gmapApi} from 'vue2-google-maps'

export default {
  data() {
    return {
      // view: 'map',
      // showPreview: false,
      // selected: null,
      // // km
      // radius: 1,
      // near: [],
      // markers: [],
      // infoWindow: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      windowHeight: state => state.windowHeight,
      windowWidth: state => state.windowWidth,
      devSpecs: state => state.deviceSpecs,
      offline: state => state.offline.isOffline
    }),
    myLicenses() {
      return this.$store.getters["foodEmployments/getByUser"](this.user.idWorldUser).map(e => {
        return this.$store.getters['foodLicenses/get'](e.license);
      });
    }
  },
  methods: {
    // changeView() {
    //   this.view = this.view === 'map' ? 'list' : 'map';
    // },
    // markerClick(marker) {
    //   this.selected = marker;
    //   this.infoWindow = {
    //     position: {
    //       lat: marker.lat,
    //       lng: marker.lng
    //     },
    //     text: marker.title
    //   };
    //   this.showPreview = true;
    // },
    // closePreview() {
    //   this.showPreview = false;
    //   this.infoWindow = null;
    //   this.selected = null;
    // },
    // updateNear: _.debounce(async function(){
    //   this.near = [];
    //   const map = await this.$refs.mapRef.$mapPromise;
    //   const from = {lat: map.getCenter().lat(), lng: map.getCenter().lng()};
    //   this.markers.forEach(m => {
    //     const to = {lat: m.lat, lng: m.lng};
    //     if(this.$anm22.haversineGreatCircleDistance(from, to) <= this.radius) {
    //       this.near.push(m);
    //     }
    //   }); 
    // }, 1000),
    async selectLicense(hash) {
      // Richiedo i dati della licenza
      if(!this.$store.getters['foodLicenses/getByHash'](hash)){
        try {
          const response = await this.$http.get('map/license?hash=' + hash);
          if(response.data.license) {
            await Promise.all([
              this.$store.dispatch('foodLicenses/update', {
                vlf: this.$vlf('foodLicenses'), objs: [response.data.license]
              }),
              this.$store.dispatch('works/update', {
                vlf: this.$vlf('works'), objs: response.data.works
              }),
            ]);
          } else {
            throw new Error('Invalid license selected');
          }
        } catch(e) {
          console.log(e.message);
          return false;
        }
      }
      const license = this.$store.getters['foodLicenses/getByHash'](hash);
      this.$anm22.setCookie('com-anm22-food-license', hash, 31536000);
      this.$anm22.setCookie('anm22_work', license.work, 31536000);
      this.$store.dispatch('setLicense', hash);
    },
    async goToHomepage(hash) {
      await this.selectLicense(hash);
      this.$router.push('/').catch(e => console.log(e));
    },
    async goToOrder(hash) {
      await this.selectLicense(hash);
      this.$router.push('/order').catch(e => console.log(e));
    },
    async openMenu(hash) {
      await this.selectLicense(hash);
      this.$router.push('/menu').catch(e => console.log(e));
    },
    loadData() {
      Promise.all([
        this.$store.dispatch('foodLicenses/load', this.$vlf('foodLicenses')),
        this.$store.dispatch('works/load', this.$vlf('works'))
      ]);
      this.$Progress.finish();
    }
  },
  created() {
    document.title = this.$anm22.strLang(this.lang, "Restaurants", "Ristoranti");
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, "Restaurants", "Ristoranti")
    );
    this.loadData();
    this.$http
      .get("map")
      .then(response => {
        // this.markers = response.data.markers;
        return Promise.all(
          this.$store.dispatch("foodLicenses/update", {
            vlf: this.$vlf("foodLicenses"),
            objs: response.data.licenses,
            cleanFilters: []
          }),
          this.$store.dispatch("works/update", {
            vlf: this.$vlf("works"),
            objs: response.data.works
          })
        );
      })
      .catch(error => {});
  },
  mounted() {
    // if (navigator.geolocation) {
    //   //Prende la posizione e richiama la funzione centerMap con le coordinate appena trovate
    //   navigator.geolocation.getCurrentPosition(
    //     pos => {
    //       // Wait for the map to be loaded before setting center
    //       this.$refs.mapRef.$mapPromise.then(map => {
    //         map.setCenter({
    //           lat: pos.coords.latitude,
    //           lng: pos.coords.longitude
    //         });
    //         map.setZoom(15);
    //       })
    //       .catch(e => console.log(e));
    //     },
    //     err => {
    //       console.log(err.message);
    //     },
    //     { enableHighAccuracy: true }
    //   );
    // }
  },
  components: {
    LicenseCard
  }
};
</script>

<style lang="scss" scoped>
html {
  overflow: hidden;
}
body {
  // position: fixed;
  // width: 100% !important;
  -webkit-overflow-scrolling: touch;
}
.content-div {
  overflow-y: auto;
  position: relative;
  width: 100%;
  // width: calc(100vw - 60px);
  // top: 60px;
  // left: 60px;
}
.switch-btn {
  width: 100px;
  justify-content: center;
  color: #222;
  background-color: #fff;
  border-radius: 20px;
  padding: 10px;
  &:hover {
    background-color: #eee;
  }
}
// #switchBtn {
//   width: 100px;
//   color: #222 !important;
//   background-color: #fff !important;
//   border-radius: 20px;
//   padding: 10px;
// }
// #switchBtn:hover {
//   background-color: #eee !important;
// }
.preview-div {
  z-index: 100;
  position: absolute;
  // top: 0;
  height: 100%;
  background-color: #fff;
  overflow: auto;
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
  &.slide-in {
      animation: slide-in 0.5s forwards;
      -webkit-animation: slide-in 0.5s forwards;
  }
  &.slide-out {
      animation: slide-out 0.5s forwards;
      -webkit-animation: slide-out 0.5s forwards;
  }
}
.preview-cover {
  width: 100%;
  height: 118px;
  object-fit: cover;
}
.preview-close-button {
  padding: 5px;
  z-index: 1000;
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: #eee;
  border-radius: 2px;
}
// @media only screen and (max-width: 767px - 1) {
//   .content-div {
//     left: 0;
//     width: 100%;
//   }
// }
@media only screen and (max-width: 991px - 1) {
  .preview-div {
    width: 100%;
  }
}
@media only screen and (min-width: 992px) {
  .preview-div {
    width: 33.333333%;
  }
}
@media only screen and (min-width: 1170px) {
  .preview-div {
    width: 25%;
  }
}
@keyframes slide-in {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(0%); }
}

@-webkit-keyframes slide-in {
    0% { -webkit-transform: translateX(-100%); }
    100% { -webkit-transform: translateX(0%); }
}
    
@keyframes slide-out {
    0% { transform: translateX(0%); }
    100% { transform: translateX(-100%); }
}

@-webkit-keyframes slide-out {
    0% { -webkit-transform: translateX(0%); }
    100% { -webkit-transform: translateX(-100%); }
}
</style>
